import React from 'react';
import ReactDOM from 'react-dom';

import PropTypes from 'prop-types';

class PaymentModal extends React.Component {
  constructor(props) {
    super(props);
    this.rootEl = document.getElementById('root');
  }
  render() {
    return (
      ReactDOM.createPortal(
        <div
          style={{
            position: 'fixed',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            top: 0,
            left: 0,
          }}
        >

          <div
            style={{
              position: 'fixed',
              width: '50%',
              height: '50%',
              backgroundColor: 'white',
            }}
          >
            <div className="row center">
              <h4>Congratulations!</h4>
              <h4>Subscription success!</h4>
              <p>Please wait a moment, we are updating your data</p>
              <button className="btn teal lighten-1 z-depth-0" onClick={this.props.onClose}>OK</button>
            </div>
          </div>
        </div>,
        this.rootEl)
    );
  }
}

PaymentModal.protoTypes = {
  onClose: PropTypes.func,
}

export default PaymentModal;